import login from "./Auth/login";
import register from "./Auth/register";
import logout from "./Auth/logout";
import backgroundUser from "./Auth/background-user";
import role from "./Auth/role";
import menu from "./Auth/menu";
import permission from "./Auth/permission";
import userPermission from "./Auth/user-permission";

import department from "./BasicInformation/department";
import factory from "./BasicInformation/factory";
import position from "./BasicInformation/position";
import workplace from "./BasicInformation/workplace";
import interviewPlace from "./BasicInformation/interview-place";
import education from "./BasicInformation/education";
import localization from "./BasicInformation/localization";
import configSetting from "./BasicInformation/config-setting";
import recruitmentMethod from "./BasicInformation/recruitment-method";
import salaryType from "./BasicInformation/salary-type";
import country from "./BasicInformation/country";
import address from "./BasicInformation/address";
import certificate from "./BasicInformation/certificate";
import driverLicense from "./BasicInformation/driver-license";
import language from "./BasicInformation/language";
import employeePlant from "./BasicInformation/employee-plant";
import employeeDepartment from "./BasicInformation/employee-department";
import workShift from "./BasicInformation/work-shift";
import defaultMessage from "./BasicInformation/default-message";
import contactInfo from "./BasicInformation/contact-info";

import appointment from "./AppointmentModule/appointment";

import rpa from "./RPA/rpa";

import notice from "./Notice/notice";

import frontPage from "./FrontPage/front-page";
import jobSetting from "./JobViewer/job-setting";
import mailTemplate from "./Template/mail";

import manpowerDemand from "./ManpowerDemandModule/manpower-demand";
import jobOpening from "./ManpowerDemandModule/job-opening";

import personalStatement from "./ResumeModule/personal-statement";
import resume from "./ResumeModule/resume";
import resumeTag from "./ResumeModule/resume-tag";
import c104 from "./ResumeModule/c104";
import c1111 from "./ResumeModule/c1111";

import recruitment from "./Recruitment/recruitment";
import interview from "./Recruitment/interview";
import jobManagement from "./Recruitment/job-management";
import onBoard from "./Recruitment/on-board";
import sendmail from "./Recruitment/sendmail";
import hcpInfo from "./Recruitment/hcp-info";
import personnelInformation from "./Recruitment/personnel-information";
import opening from "./Recruitment/opening";
import contract from "./Recruitment/contract";
import incomeTax from "./Recruitment/income-tax";

import approveInterview from "./Recruitment/approve-interview";

import hr from "./Progress/hr";
import supervisor from "./Progress/supervisor";

import file from "./FileUpload/file";
import scs from "./OtherSystem/scs";

import idl from "./ResumeModule/Customize/idl";
import dl from "./ResumeModule/Customize/dl";
import viewResume from "./ResumeModule/Customize/view-resume";
import contactRecord from "./ResumeModule/Customize/contact-record";

import userLogin from "./Report/user-login";
import blacklist from "./Report/blacklist";
import chart from "./Report/chart";

import talentPool from "./Talent/talent-pool";

import InterviewSch from "./InterviewSch/InterviewSch";

export default {
  login,
  register,
  logout,
  backgroundUser,
  role,
  menu,
  permission,
  userPermission,
  department,
  factory,
  position,
  workplace,
  interviewPlace,
  education,
  localization,
  configSetting,
  recruitmentMethod,
  salaryType,
  country,
  address,
  certificate,
  driverLicense,
  language,
  employeePlant,
  employeeDepartment,
  workShift,
  defaultMessage,
  contactInfo,

  appointment,

  rpa,

  notice,

  frontPage,
  jobSetting,
  mailTemplate,

  manpowerDemand,
  jobOpening,
  
  personalStatement,
  resume,
  resumeTag,
  c104,
  c1111,

  recruitment,
  interview,
  jobManagement,
  onBoard,
  sendmail,
  hcpInfo,
  personnelInformation,
  opening,
  contract,
  incomeTax,
  
  hr,
  supervisor,

  approveInterview,

  file,
  scs,

  idl,
  dl,
  viewResume,
  contactRecord,
  
  userLogin,
  blacklist,
  chart,

  talentPool,

  InterviewSch
};
